import { render, staticRenderFns } from "./myPostcard.vue?vue&type=template&id=71d45252&scoped=true"
import script from "./myPostcard.vue?vue&type=script&lang=js"
export * from "./myPostcard.vue?vue&type=script&lang=js"
import style0 from "./myPostcard.vue?vue&type=style&index=0&id=71d45252&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d45252",
  null
  
)

export default component.exports